import * as React from "react";
import {useTranslation} from "react-i18next";
import Box from "@mui/material/Box";

import LoginForm from "../../auth/auth-tabs/login-form/LoginForm";
import RegisterForm from "../../auth/auth-tabs/register-form/RegisterForm";
import CustomTabs from "../../shared/custom-tabs/CustomTabs";

export default function AuthTabs() {
    const {t} = useTranslation();
    const [value, setValue] = React.useState(0);

    const handleChange = (_: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const tabs = [
        {
            title: t("existing_user"),
            component: <LoginForm/>,
        },
        {
            title: t("new_user"),
            component: <RegisterForm/>,
        },
    ];

    return (
        <Box width="100%">
            <CustomTabs
                variant="fullWidth"
                tabs={tabs} spacing={0} noTabLabel
                color="primary"
                selectedTab={value}
                handleTabChange={handleChange}
            />
        </Box>
    );
}
